module.exports = __webpack_public_path__ + "static/img/card_1_12.769d721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_1_12.png
// module id = JL5n
// module chunks = 0